import API from './API';
import CommentActions from 'actions/CommentActions';
import {browserHistory} from 'react-router';


const CommentSource = {
  getRemoteComments: {
    remote(state) {
      let url = `${API.getComment}&media_id=${state.media_id}&first=${state.first}&maxCount=${state.maxCount}`;
      return fetch(url).then(res=>res.json());
    },
    // local(state) {
    //   return null;
    // },
    shouldFetch(state) {
      if(state.media_id) {
        return true;
      }
    },
    // loading() {},
    success: CommentActions.receivedComments,
    error: CommentActions.fetchCommentsFailed
  },

  postRemoteComment: {
    remote(state) {
      let data = `media_id=${state.postComment.media_id}&content=${state.postComment.content}&accessToken=${API.accessToken}`;
      let param = {
          method: 'POST',
          body: data,
          headers: API.urlHeader
      };
      return fetch(`${API.postComment}`, param)
        .then(res=>res.json());
    },
    // local(state) {
    //   return null;
    // },
    shouldFetch() {
      if(API.accessToken) {
        return true;
      } else {
        browserHistory.push('/login');
      }
    },
    // loading() {},
    success: CommentActions.postCommentSuccess,
    error: CommentActions.postCommentsFailed
  }
};

export default CommentSource;



// WEBPACK FOOTER //
// ./src/sources/CommentSource.js